import React from 'react';
import css from './HeroSection.module.css';

const categories = [
  {
    id: 'solar',
    label: 'Solar Energy',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="4"></circle>
        <path d="M12 2v2"></path>
        <path d="M12 20v2"></path>
        <path d="m4.93 4.93 1.41 1.41"></path>
        <path d="m17.66 17.66 1.41 1.41"></path>
        <path d="M2 12h2"></path>
        <path d="M20 12h2"></path>
        <path d="m6.34 17.66-1.41 1.41"></path>
        <path d="m19.07 4.93-1.41 1.41"></path>
      </svg>
    ),
  },
  {
    id: 'wind',
    label: 'Wind Energy',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12.8 19.6A2 2 0 1 0 14 16H2"></path>
        <path d="M17.5 8a2.5 2.5 0 1 1 2 4H2"></path>
        <path d="M9.8 4.4A2 2 0 1 1 11 8H2"></path>
      </svg>
    ),
  },
  {
    id: 'efficiency',
    label: 'Energy Efficiency',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
      </svg>
    ),
  },
  {
    id: 'waste',
    label: 'Waste Management',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"></path>
        <path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"></path>
        <path d="m14 16-3 3 3 3"></path>
        <path d="M8.293 13.596 7.196 9.5 3.1 10.598"></path>
        <path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"></path>
        <path d="m13.378 9.633 4.096 1.098 1.097-4.096"></path>
      </svg>
    ),
  },
  {
    id: 'building',
    label: 'Green Building',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 12h4"></path>
        <path d="M10 8h4"></path>
        <path d="M14 21v-3a2 2 0 0 0-4 0v3"></path>
        <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"></path>
        <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16"></path>
      </svg>
    ),
  },
  {
    id: 'consulting',
    label: 'Environmental Consulting',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
        <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
        <path d="M10 9H8"></path>
        <path d="M16 13H8"></path>
        <path d="M16 17H8"></path>
      </svg>
    ),
  },
];

const HeroSection = () => {
  return (
    <section className={css.heroSection}>
      <div className={css.heroContainer}>
        <p className={css.eyebrow}>Environmental pros, vetted and local</p>
        <h1 className={css.heroTitle}>Find Trusted Environmental Pros Fast</h1>
        <p className={css.heroDescription}>
          Your trusted hub to find a professional for environmental safety, testing, remediation, and restoration services.
        </p>

        <div className={css.searchShell}>
          <div className={css.searchIcon}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </div>
          <input
            type="text"
            className={css.searchInput}
            placeholder="Search for environmental services..."
            aria-label="Search for environmental services"
          />
          <button className={css.searchButton}>Search</button>
        </div>

        <div className={css.categoriesStrip}>
          {categories.map(cat => (
            <div key={cat.id} className={css.categoryItem}>
              <span className={css.categoryIcon}>{cat.icon}</span>
              <span className={css.categoryLabel}>{cat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
